import React from 'react';

import {observer} from 'mobx-react';
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {EntityScoresWidgetGroupHeaderEntity} from "./entity-scores-widget.group-header.entity";
import {Link} from "../../../../core/components/link/link";
import classNames from "classnames";
import styles from "../../styles/entity-scores-widget-group.module.scss";

export class EntityScoresGroupHeaderProps extends BaseProps {}

export const EntityScoresWidgetGroupHeader = observer(({group, controller}: EntityScoresGroupHeaderProps) => {
  const {state} = controller;
  const {entityContext} = state;
  const {shouldRenderEntityHeader} = entityContext;
  const {entity, date, title} = group;
  const {domainModel, linkModel} = entity;

  const headerProps = {
    className: classNames(styles.header_container, {[styles.no_entity_container]: !shouldRenderEntityHeader}),
    model: shouldRenderEntityHeader ? linkModel : null,
    routeProps: {
      dataSource: {
        entity: domainModel
      }
    }
  };

  const entityHeaderProps = {
    controller,
    group
  }

  return (
    <Link {...headerProps}>
      {
        shouldRenderEntityHeader ?
          <EntityScoresWidgetGroupHeaderEntity {...entityHeaderProps}/> :
          <div className={classNames(styles.header_title)}>{title}</div>

      }
      <div className={classNames(styles.header_date)}>{date}</div>
    </Link>
  );
});
